import SignupComponent from "../components/SignupForm";

const signup = () => {
    return (
        <SignupComponent />
    );
}

export default signup;